import { Grid, useMediaQuery, useTheme } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { ReactNode, useContext } from "react";

import styles from "../styles";

interface Props {
  children: ReactNode;
}

const MainWrapper = ({ children }: Props) => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { upgradeDialogSource } = useContext(SubscriptionContext);
  return (
    <Grid
      container
      alignItems={"stretch"}
      sx={
        upgradeDialogSource && !isMobileScreen
          ? {}
          : { position: "absolute", bottom: 0, top: 0 }
      }
    >
      {children}
    </Grid>
  );
};

const LeftSidebarWrapper = ({ children }: Props) => {
  const { upgradeDialogSource } = useContext(SubscriptionContext);
  return (
    <Grid
      item
      xs={12}
      md={5}
      sx={styles.leftContainer(upgradeDialogSource !== null)}
      container
    >
      {children}
    </Grid>
  );
};

const RightSidebarWrapper = ({ children }: Props) => {
  return (
    <Grid container item xs md sx={styles.rightContainer}>
      {children}
    </Grid>
  );
};

export { MainWrapper, LeftSidebarWrapper, RightSidebarWrapper };
